<template>
    <b-form-group :label-for="`range-of-performance-value-${range.id.$model}`">
        <b-input-group :prepend="`${parseInt(index) + 1}º`">
            <b-form-input
                :id="`range-of-performance-value-${range.id.$model}`"
                :value="value"
                @input="$emit('update:value', $event)"
                :state="state"
                :disabled="disabled"
                :placeholder="placeholder"
                :aria-describedby="`range-of-performance-value-feedback-${range.id.$model}`"
            />
            <b-form-invalid-feedback :id="`range-of-performance-value-feedback-${range.id.$model}`">
                <slot />
            </b-form-invalid-feedback>
        </b-input-group>
    </b-form-group>
</template>

<script>
export default {
    name: 'Description',
    props: ['value', 'state', 'disabled', 'placeholder', 'range', 'index'],
}
</script>
